import InfiniteScroll from 'infinite-scroll'
import imagesLoaded from 'imagesloaded'

const nav = document.querySelector('.reviews-nav .nav-previous a')

if (nav) {
  InfiniteScroll.imagesLoaded = imagesLoaded

  const request = new InfiniteScroll('.all-reviews__reviews', {
    path: '.nav-previous a',
    append: '.feed-ajax-post',
    status: '.page-load-status',
    hideNav: '.reviews-nav',
    button: '.load-more',
    scrollThreshold: false,
    history: false,
  })

  const requestButton = document.querySelector('.load-more')
  let isLast = false

  request.on('request', function () {
    requestButton.style.display = 'none'
  })

  request.on('append', function () {
    if (!isLast) requestButton.style.display = ''
  })

  request.on('last', function () {
    isLast = true
  })
}
